export const TOP_FEATURES_TITLES_CONFIG = [
  {
    title: '24/7 online bookings',
    description:
      'Allow your clients to book appointments online any time, from anywhere. You’ll take fewer calls, gain more bookings and keep your calendar full.',
    icon: 'Calendar',
  },
  {
    title: 'Easy to use booking software',
    description:
      'Forget complicated booking platforms. Pata keeps things simple, with just the tools you need to manage bookings and clients without the clutter.',
    icon: 'Desktop',
  },
  {
    title: 'Appointment booking made simple',
    description:
      'Say goodbye to pen and paper. Pata helps you manage appointments, track bookings and stay organised every day with an intuitive calendar built for pet care businesses.',
    icon: 'CalendarPerson',
  },
  {
    title: 'Get discovered by more pet owners',
    description:
      'List your public pet business profile on the Pata marketplace to reach local pet owners, grow your client base and take bookings online.',
    icon: 'Megaphone',
  },
  {
    title: 'Protect your business from no-shows',
    description:
      'Take deposits before appointments and store payment cards for later charges, protecting your time and reducing last-minute cancellations. You stay in control of how and when you get paid.',
    icon: 'NoShow',
  },
  {
    title: 'Automated reminders and client messages',
    description:
      'Automatically send appointment reminders, confirmations and review requests to stay connected with your clients and reduce no-shows without extra work.',
    icon: 'TextMessage',
  },
];
